import React, { useRef, useState, useEffect, useCallback } from 'react';
import { func } from 'prop-types';
import { ChevronRightIcon } from '@snapask/common-components';

import styles from './DragScroll.scss';
function DragScroll({ children }) {
  const [isScrolling, setIsScrolling] = useState(false);
  const [isScrollable, setIsScrollable] = useState(false);
  const [mouseX, setMouseX] = useState(0);

  const scrollRoot = useRef(null);
  const scrollChildren = useRef(null);

  const checkIsScrollable = useCallback(() => {
    if (!scrollRoot.current || !scrollChildren.current) return;

    const rootClientWidth = scrollRoot.current.clientWidth;
    const rootScrollWidth = scrollChildren.current.clientWidth;
    setIsScrollable(rootScrollWidth > rootClientWidth);
  }, []);

  useEffect(() => {
    const handleResize = window.addEventListener('resize', checkIsScrollable);

    return window.removeEventListener('resize', handleResize);
  }, [checkIsScrollable]);

  const onMouseDown = e => {
    setIsScrolling(true);
    setMouseX(!!e.touches ? e.touches[0].clientX : e.clientX);
  };
  const onMouseUp = () => setIsScrolling(false);
  const onMouseMove = e => {
    if (!isScrolling) return;

    const newMouseX = !!e.touches ? e.touches[0].clientX : e.clientX;
    const distance = newMouseX - mouseX;
    processScroll(distance);
    setMouseX(newMouseX);
  };

  const processScroll = distance => {
    const prevScrollLeft = scrollRoot.current.scrollLeft;
    scrollRoot.current.scrollLeft = prevScrollLeft - distance;
  };

  const scrollActions = { checkIsScrollable };
  return (
    <React.Fragment>
      <div
        className={styles.root}
        onMouseDown={onMouseDown}
        onTouchStart={onMouseDown}
        onMouseUp={onMouseUp}
        onTouchEnd={onMouseUp}
        onMouseLeave={onMouseUp}
        onMouseMove={onMouseMove}
        onTouchMove={onMouseMove}
        ref={scrollRoot}
      >
        <div ref={scrollChildren} className={styles.children}>
          {children(scrollActions)}
        </div>
      </div>
      {isScrollable && (
        <ChevronRightIcon width={24} height={24} className={styles.arrowIcon} />
      )}
    </React.Fragment>
  );
}
DragScroll.propTypes = {
  children: func.isRequired,
};
export default DragScroll;



// WEBPACK FOOTER //
// ./app/components/PageListHeader/components/DragScroll/DragScroll.jsx